import { usePropertyDetailsContext } from "../contexts/property-details-context.tsx";

/**
 * Reports a click to the internal "Joe" reporting backend. Returns a callback that posts
 * `{ reference, source }` for the current property to the given `/reporting/...` endpoint.
 *
 * Uses `sendBeacon` so the request survives the navigation or new tab the click triggers.
 */
export function useReportClick() {
  const { propertyReference, propertySource } = usePropertyDetailsContext();
  return (endpoint: string) => {
    if (propertyReference == null) return;
    const body = JSON.stringify({ reference: propertyReference, source: propertySource });
    navigator.sendBeacon(endpoint, new Blob([body], { type: "application/json" }));
  };
}
